module.exports = __webpack_public_path__ + "img/flow.de.a18b33b2.svg";